import React from "react";
import ReactDOM from "react-dom";
import { init } from "@rematch/core";
import { Provider } from "react-redux";
import * as models from "./models";
import App from "./App";
import './index.css'
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { BrowserRouter } from "react-router-dom";


const theme = createTheme({
  typography: {
    fontFamily: [
      'Montserrat',
      'Roboto',
      '"Helvetica Neue"',
      'Arial'
    ].join(','),
  },
});

// generate Redux store
const store = init({
  models
});

const Root = () => (
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ThemeProvider>
);

ReactDOM.render(<Root />, document.querySelector("#root"));
